import { z } from "zod";

const amountsSchema = z.record(
  z.object({
    amount: z
      .string()
      .regex(/^\d+(\.\d+)?$/)
      .transform(Number),
    meta: z.object({}).nullish(),
  }),
);

const optionallyNegativeAmountSchema = z.record(
  z.object({
    amount: z
      .string()
      .regex(/^[-]?\d+(\.\d+)?$/)
      .transform(Number),
    meta: z.object({}).nullish(),
  }),
);

const baseRowSchema = z.object({
  id: z.string().min(1),
  category_id: z.string(),
  fund_family: amountsSchema,
  funds: z.record(amountsSchema),
});

const txCodeColumnDataSchema = z.object({
  use_of_funds: z.object({
    transaction_code_id: z.string(),
  }),
});

const rowSchema = z.discriminatedUnion("category_id", [
  baseRowSchema.extend({
    category_id: z.literal("management_fees"),
    column_data: z.object({
      use_of_funds: z.object({
        fee_id: z.string(),
      }),
    }),
    fund_family: optionallyNegativeAmountSchema,
    funds: z.record(optionallyNegativeAmountSchema),
  }),
  baseRowSchema.extend({
    category_id: z.literal("investment"),
    column_data: txCodeColumnDataSchema,
  }),
  baseRowSchema.extend({
    category_id: z.literal("expenses"),
    column_data: txCodeColumnDataSchema,
  }),
  baseRowSchema.extend({
    category_id: z.literal("taxes"),
    column_data: txCodeColumnDataSchema,
  }),
  baseRowSchema.extend({
    category_id: z.literal("capital_reserves"),
    column_data: txCodeColumnDataSchema,
  }),
  baseRowSchema.extend({
    category_id: z.literal("bridge_financing"),
    column_data: txCodeColumnDataSchema,
  }),
]);

export const capitalCallCreateSchema = z.object({
  rows: z.array(rowSchema).nonempty(),
});
